module.exports = __webpack_public_path__ + "static/Fivetran-b3ef001701c199b4d5a7766f092b556e.jpg";